<!-- src/components/CookieConsent.vue -->
<template>
  <div v-if="showBanner" class="cookie-banner">
    <p>
      {{ $t('message.cookie.text') }}
    </p>
    <button class="btn btn-dark" @click="declineCookies">{{ $t('message.cookie.decline') }}</button>
    <button class="btn btn-light" @click="acceptCookies">{{ $t('message.cookie.accept') }}</button>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: false,
      GA_MEASUREMENT_ID: 'G-CRCNKZ7X3J' //  ID GA4
    };
  },
  mounted() {
    const consentLocal = localStorage.getItem('cookieConsent');
    const consentSession = sessionStorage.getItem('cookieConsent');

      if (!consentLocal && !consentSession) {
      // Mostra banner solo se non c’è nessuna preferenza salvata
      this.showBanner = true;
    } else if (consentLocal === 'accepted') {
      // Se aveva già accettato in passato, carica GA subito
      this.loadGoogleAnalytics();
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookieConsent', 'accepted'); // Persistente
      sessionStorage.removeItem('cookieConsent'); // Rimuove eventuale valore temporaneo
      this.showBanner = false;
      this.loadGoogleAnalytics();
    },
    declineCookies() {
      sessionStorage.setItem('cookieConsent', 'declined'); // Solo per la sessione
      localStorage.removeItem('cookieConsent'); // Non salva nel lungo periodo
      this.showBanner = false;
    },
    loadGoogleAnalytics() {
      // Evita di caricare due volte lo script
      if (window.gtag) return;

      // Crea dinamicamente lo script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);

      // Inizializza GA4
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', this.GA_MEASUREMENT_ID);
    }
  }
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #222;
  color: #fff;
  padding: 15px;
  text-align: center;
  z-index: 1000;
}
.cookie-banner button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
